// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ZUOx","paramInput":"JobSimulator_paramInput__302U8","input":"JobSimulator_input__3bloD"};